import React, { useEffect, useRef, useState } from "react";
import {
  Button,
  Popover,
  Form,
  Input,
  Upload,
  message,
  Modal,
  Menu,
  Select,
  FloatButton,
} from "antd";

import { contactSupportAction } from "../../store/action/admin/settingAction";
import { useDispatch, useSelector } from "react-redux";
import ContactSupportIcon from "../../Icons/ContactSupportIcon";
import TickIcon from "../../Icons/TickIcon";
import { css, keyframes } from "@emotion/css";
import MessageQuestionIcon from "../../Theme/CustomIcons/Icons/Support,Like,Question/MessageQuestionIcon";
import { toggleSupportCard } from "../../store/action/admin/onboardingActions";
import { TranslatorSupportTag } from "../../languageTranslator/LanguageTranslatorTags";
import PaperClipIcon from "../../Theme/CustomIcons/Icons/Type,Paragraph,Character/PaperClipIcon";
import CloseCircleIcon from "../../Theme/CustomIcons/Icons/Essetional/CloseCircleIcon";
import ArrowCircleRight2Icon from "../../Theme/CustomIcons/Icons/Arrow/ArrowCircleRight2Icon";
const { TextArea } = Input;

const ContactSupport = ({ dashboard, auth }) => {
  const [form] = Form.useForm();
  const dispatch = useDispatch();
  const popupRef = useRef(null);
  const selectRef = useRef(null);
  const [open, setOpen] = useState(false);
  const [showMessage, setShowMessage] = useState(false);
  const contactSupportList = useSelector((state) => state.contactSupportList);
  const sharedUserInfo = useSelector(
    (state) => state.sharedLogin.sharedUserInfo
  );
  const isSupportCardVisible = useSelector(
    (state) => state.supportCard.isSupportCardVisible
  );
  const getLanguageTranslatorList = useSelector(
    (state) => state.getLanguageTranslatorList
  );
  const { translations } = getLanguageTranslatorList;

  const expand = keyframes`
  0% {
    clip-path: circle(0px at bottom ${
      translations?.direction === "rtl" ? "left" : "right"
    });
    display: none;
  }
  1% {
    clip-path: circle(0px at bottom ${
      translations?.direction === "rtl" ? "left" : "right"
    });
    display: block;
  }
  100% {
    clip-path: circle(700px at bottom ${
      translations?.direction === "rtl" ? "left" : "right"
    });
    display: block;
  }
`;

  const collapse = keyframes`
  0% {
    clip-path: circle(700px at bottom ${
      translations?.direction === "rtl" ? "left" : "right"
    });
    display: block;
  }
  99% {
    clip-path: circle(0px at bottom ${
      translations?.direction === "rtl" ? "left" : "right"
    });
  }
  100% {
    clip-path: circle(0px at bottom ${
      translations?.direction === "rtl" ? "left" : "right"
    });
    display: none;
  }
`;

  const popupExpand = css`
    animation: ${expand} 0.5s forwards;
  `;

  const popupCollapse = css`
    animation: ${collapse} 0.5s forwards;
  `;
  const toggleCardVisibility = () => {
    dispatch(toggleSupportCard(!isSupportCardVisible));
  };
  const handleFinish = async (values) => {
    try {
      const formData = new FormData();

      formData.append("description", values.description);
      formData.append("subject", values.subject);
      if (
        values.attachment &&
        values.attachment.fileList &&
        values.attachment.fileList.length > 0
      ) {
        values.attachment.fileList.map((e, index) => {
          formData.append(`attachment`, e.originFileObj);
        });
      }
      await dispatch(contactSupportAction(formData));
      message.success("Sent successfully!");
      form.resetFields();
      setShowMessage(true);
    } catch (err) {
      message.error("Try Again");
    }
  };

  const uploadProps = {
    beforeUpload: (file) => {
      return false;
    },
  };

  const hide = () => {
    dispatch(toggleSupportCard(false));
    setOpen(false);
    setShowMessage(false);
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        popupRef.current &&
        !popupRef.current.contains(event.target) &&
        !event.target.closest(".select-class")
      ) {
        event.preventDefault();
        hide();
      }
    };

    window.addEventListener("mousedown", handleClickOutside);

    return () => {
      window.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);
  const themeDefault = useSelector((state) => state.themeDefault);
  let themeValue = themeDefault?.info?.newConfig;
  return (
    <div
      style={{
        position: dashboard ? "" : "absolute",
        bottom: "16px",
        left: "0px",
        right: "0px",
      }}
    >
      {isSupportCardVisible === true && (
        <div
          ref={popupRef}
          className={
            (isSupportCardVisible ? popupExpand : popupCollapse) +
            " " +
            css`
              position: fixed;

              bottom: 50px;
              ${translations?.direction === "rtl"
                ? "left: 90px;"
                : "right: 90px;"}
              width: 340px;
              height: 566px;
              border-radius: ${themeDefault?.info?.borderRadius}px;
              // background: linear-gradient(
              //   180deg,
              //   #260b3b 25.42%,
              //   #5a466a 36%,
              //   ${themeDefault?.info?.newConfig
                ?.backgroundAccentColor} 54.88%
              // );
              padding: 16px;
              z-index: 1000;
              // box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
            `
          }
        >
          <div
            ref={popupRef}
            className={
              (isSupportCardVisible ? popupExpand : popupCollapse) +
              " " +
              css`
                position: absolute;

                bottom: 0;
                left: 0;
                // bottom: -570px;
                // left: -860px;

                // left: calc(-100% - 426px);
                width: 340px;
                height: 566px;
                border-radius: ${themeDefault?.info?.borderRadius}px;

                backdrop-filter: blur(50px);

                background: ${themeValue?.theme === "purple"
                  ? "linear-gradient(180deg, #260A2F 25.42%, rgba(255, 255, 255, 0.08) 54.88%)"
                  : themeValue?.theme === "default"
                  ? " linear-gradient(180deg,#260a2f 25.42%,#443249 36%,#ffffff 54.88%)"
                  : "linear-gradient(180deg, #000000 25.42%, rgba(255, 255, 255, 0.08) 54.88%)"};

                padding: 16px;
                z-index: 1000;
                box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
              `
            }
          >
            <img
              style={{
                width: "100%",
                opacity: "0.5",
                borderRadius: `${themeDefault?.info?.borderRadius}px ${themeDefault?.info?.borderRadius}px 0px 0px`,
                position: "absolute",
                top: 0,
                left: 0,
                margin: "auto",
                display: "block",
              }}
              src="/pics/contact-support-bg_new.png"
            />
            <div
              style={{
                width: "100%",
                position: "absolute",
                top: 0,
                left: 0,
                height: 360,
                // background: 'rgb(255 255 255 / 14%)',
                // background:
                //   "linear-gradient(rgb(217 217 217 / 5%) 0%, rgba(115, 115, 115, 0) 100%)",
              }}
            />
            <div style={{ height: "252px", position: "relative" }}>
              <div
                style={{
                  display: "flex",
                  flexDirection: "row",
                  justifyContent: "space-between",
                  color: "white",
                  alignItems: "center",
                  fontSize: "20px",
                  zIndex: "10",
                  position: "relative",
                }}
              >
                <img src="/pics/Max_Logo_White.png" width={96} />
                <div
                  style={{
                    display: "flex",
                    flexDirection: "row",
                    gap: "8px",
                    alignItems: "center",
                  }}
                >
                  <div>
                    <img
                      src="/pics/avatar_contact_1.png"
                      width={28}
                      style={{ position: "relative", left: 8 }}
                    />
                    <img src="/pics/avatar_contact_2.png" width={28} />
                  </div>
                  <div style={{ cursor: "pointer" }} onClick={hide}>
                    <CloseCircleIcon color="#fff" />
                  </div>
                </div>
              </div>
              <div
                style={{
                  position: "absolute",
                  bottom: 8,
                  width: "100%",
                }}
              >
                <h3
                  style={{
                    color: "white",
                    margin: 0,
                    fontSize: "28px",
                    fontWeight: "600 !important",
                  }}
                >
                  <span style={{ opacity: ".8" }}>
                    <TranslatorSupportTag>Hi</TranslatorSupportTag>{" "}
                    {sharedUserInfo?.payload?.name?.firstName}
                  </span>{" "}
                  👋
                </h3>
                <h3
                  style={{
                    color: "white",
                    margin: 0,
                    fontSize: "28px",
                    lineHeight: "22px",
                    marginBottom: "20px",
                    fontWeight: "600 !important",
                  }}
                >
                  <TranslatorSupportTag>How can we help?</TranslatorSupportTag>
                </h3>
              </div>
            </div>
            <div
              style={{
                background:
                  themeValue?.theme === "purple"
                    ? "#260A2F3D"
                    : themeValue?.theme === "default"
                    ? "white"
                    : "  #FFFFFF26",
                // background: "rgb(46 16 48 / 18%)",
                // background: "white",
                backdropFilter: " blur(50px)",

                padding: "12px",
                borderRadius: "8px",
                maxHeight: "284px",
                overflow: "auto",
                height: "100%",
                position: "relative",
              }}
            >
              {showMessage ? (
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    height: "100%",
                    justifyContent: "center",
                    gap: "8px",
                  }}
                >
                  <TickIcon style={{ color: "#2FD6A4", fontSize: "48px" }} />
                  <p style={{ textAlign: "center" }}>
                    <TranslatorSupportTag>
                      The form has been submitted, Our team will get back to you
                      within 24-48 hours.
                    </TranslatorSupportTag>
                  </p>
                </div>
              ) : (
                <Form
                  layout="vertical"
                  onFinish={handleFinish}
                  form={form}
                  style={{ width: "100%" }}
                >
                  <Form.Item
                    name="subject"
                    rules={[
                      {
                        required: true,
                        message: (
                          <TranslatorSupportTag>
                            Please input the subject!
                          </TranslatorSupportTag>
                        ),
                      },
                    ]}
                  >
                    <Select
                      placeholder="Enter Subject"
                      className="select-class"
                      popupClassName="select-class"
                    >
                      <Select.Option value="Help and Support">
                        <TranslatorSupportTag>
                          Help and Support
                        </TranslatorSupportTag>
                      </Select.Option>
                      <Select.Option value="Technical Issue">
                        {" "}
                        <TranslatorSupportTag>
                          Technical Issue
                        </TranslatorSupportTag>
                      </Select.Option>
                      <Select.Option value="Feature Request">
                        {" "}
                        <TranslatorSupportTag>
                          Feature Request
                        </TranslatorSupportTag>
                      </Select.Option>
                      <Select.Option value="Others">
                        <TranslatorSupportTag>Others</TranslatorSupportTag>
                      </Select.Option>
                    </Select>
                  </Form.Item>
                  <Form.Item
                    name="description"
                    rules={[
                      {
                        required: true,
                        message: (
                          <TranslatorSupportTag>
                            Please input the description!
                          </TranslatorSupportTag>
                        ),
                      },
                    ]}
                  >
                    <TextArea
                      style={{ resize: "none" }}
                      autoSize={false}
                      rows={2}
                      placeholder="Enter Description"
                    />
                  </Form.Item>
                  <Form.Item name="attachment">
                    <Upload.Dragger {...uploadProps}>
                      <PaperClipIcon />{" "}
                      <TranslatorSupportTag>
                        Add up to 5 Attachments.
                      </TranslatorSupportTag>
                    </Upload.Dragger>
                  </Form.Item>
                  <div>
                    <Button
                      type="primary"
                      htmlType="submit"
                      style={{ height: "36px", width: "100%" }}
                      onClick={() => form.submit()}
                      loading={contactSupportList?.loading}
                      disabled={contactSupportList?.loading}
                    >
                      <TranslatorSupportTag>Submit</TranslatorSupportTag>
                    </Button>
                  </div>
                </Form>
              )}
            </div>
          </div>
        </div>
      )}
      {/* <div
        style={{
          width: "100%",
          display: "flex",
          justifyContent: "center",
          fontSize: "26px",
          cursor: "pointer",
        }}
        
      > */}

      <FloatButton
        shape="circle"
        // type="primary"
        // style={{
        //   right: 25,
        // }}
        className={css`
          .ant-float-btn-icon {
            width: 100% !important;
          }
          .ant-float-btn-content {
            padding: 0px !important;
          }
          .ant-float-btn-body {
            background: linear-gradient(
              200deg,
              ${themeDefault?.info?.newConfig?.colorPrimaryShades[4]},
              ${themeDefault?.info?.newConfig?.colorPrimaryShades[5]},
              ${themeDefault?.info?.newConfig?.colorPrimaryShades[7]}
            ) !important;
          }
          width: clamp(45px, calc(2.4vw + 21px), 60px);
          height: clamp(45px, calc(2.4vw + 21px), 60px);
        `}
        onClick={() => {
          if (open === true) {
            dispatch(toggleSupportCard(false));
            setOpen(false);
          } else {
            dispatch(toggleSupportCard(true));
            setOpen(true);
          }
        }}
        icon={
          <MessageQuestionIcon
            className={css`
              font-size: clamp(12px, 1.5vw, 24px);
              color: ${themeDefault?.info?.newConfig
                ?.colorTextSecondary} !important;
            `}
            size="medium"
          />
        }
      />
    </div>
    // </div>
  );
};

export default ContactSupport;
